import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Select from 'react-select'
import styled from 'styled-components'
import { getRounds } from '../../services/config-services'
import { transformBuddhistDateToChristianDate } from '../../helpers/helpers'
import { Step, StepLabel, Stepper } from '@mui/material'
import axios from 'axios'
import Cookies from 'js-cookie'
import config from '../../config'
import PrizeState from './PrizeState'
import { Card } from 'react-bootstrap'
import { PRIZE_STATES_LABEL } from '../../constants/prizes'

const NumberOfPrizes = () => {
  const dispatch = useDispatch()
  const [allRound, setAllRound] = useState(null)
  const [selectedRound, setSelectedRound] = useState(null)
  const [states, setStates] = useState([])
  const [currentState, setCurrentState] = useState()

  const getStates = useCallback(async () => {
    dispatch({ type: 'loading_show' })
    const response = await axios.get(
      `${config.apiAdminGateway}/api/v2/prizes/state?roundDate=${selectedRound?.value}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (response.data.status.code === 0) {
      const data = response.data.data
      setStates(data.events)
      setCurrentState(data.currentEvent)
    }
    dispatch({ type: 'loading_hide' })
  }, [dispatch, selectedRound?.value])

  useEffect(() => {
    const fetchAllRounds = async () => {
      const response = await getRounds()
      const rounds = response
        .map((round) => {
          return {
            value: round.value,
            label: round.value,
            time: transformBuddhistDateToChristianDate(round.value).getTime(),
          }
        })
        .sort((a, b) => b.time - a.time)
      setAllRound(rounds)
      setSelectedRound(rounds[0])
    }
    dispatch({ type: 'loading_show' })
    fetchAllRounds()
    dispatch({ type: 'loading_hide' })
  }, [dispatch])

  useEffect(() => {
    if (selectedRound?.value) {
      getStates()
    }
  }, [selectedRound, getStates])

  const handleChangeRound = (value) => {
    setSelectedRound(value)
  }

  const renderRoundDate = (allRound) => (
    <SelectContainer>
      <SelectContainer.Label>งวดวันที่</SelectContainer.Label>
      <Select defaultValue={allRound[0]} onChange={handleChangeRound} options={allRound} />
    </SelectContainer>
  )

  if (allRound === null) {
    return <h3>loading</h3>
  }

  return (
    <Container>
      {renderRoundDate(allRound)}
      <Card>
        <Card.Header
          style={{
            display: 'block',
          }}
        >
          <Stepper activeStep={states.indexOf(currentState)} alternativeLabel>
            {states.map((state) => (
              <Step key={state}>
                <StepLabel>{PRIZE_STATES_LABEL[state]}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Card.Header>
        <PrizeState state={currentState} selectedRound={selectedRound} getStates={getStates} />
      </Card>
    </Container>
  )
}

export default NumberOfPrizes

const SelectContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`

SelectContainer.Label = styled.p`
  margin: 0 10px;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
